<template>
    <img
        :class="className ? className : 'royal-coin'"
        :src="royalCoinImage"
    />
</template>

<script>
import royalCoinBlackImage from '../../assets/royal_coin_black.svg?url';
import royalCoinWhiteImage from '../../assets/royal_coin_white.svg?url';
import royalCoinBlackImageAlt from '../../assets/royal_coin_black_alt.png';
import royalCoinWhiteImageAlt from '../../assets/royal_coin_white_alt.png';
import {
    THEME_TOURNAMENT_KIT,
} from '../Game/Game-types';

export default {
    name: 'RoyalCoin',
    props: [
        'theme',
        'color',
        'className',
    ],
    data() {
        return {
            black: {
                default: royalCoinBlackImage,
                alt: royalCoinBlackImageAlt,
            },
            white: {
                default: royalCoinWhiteImage,
                alt: royalCoinWhiteImageAlt,
            },
        };
    },
    computed: {
        royalCoinImage() {
            if (this.theme === THEME_TOURNAMENT_KIT) {
                return this[this.color].alt;
            }

            return this[this.color].default;
        },
    },
};
</script>

<style scoped lang="scss">

</style>
